export const Skeleton = ({ className }: { className?: string }) => {
  return (
    <div className={`animate-pulse w-1/5 h-full p-1 ${className}`}>
      <div className="py-2.5 h-full bg-slate-700 rounded" />
    </div>
  );
};
